import { render, staticRenderFns } from "./TpHistoricoPagamentos.vue?vue&type=template&id=39519694"
import script from "./TpHistoricoPagamentos.vue?vue&type=script&lang=js"
export * from "./TpHistoricoPagamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports